import { useState } from "react";
import { X, Star, Heart, ArrowLeft } from "lucide-react";
import { imgUrl } from "@/lib/api";

const Thumb = ({ src }) => {
  const [tries, setTries] = useState(0);
  const url = imgUrl(src);
  return <img src={tries ? `${url}${url.includes("?") ? "&" : "?"}r=${tries}` : url} alt="" loading="lazy" className="w-full h-full object-cover"
    onError={() => tries < 3 && setTimeout(() => setTries((t) => t + 1), 1500 * (tries + 1))} />;
};

const btn = "w-7 h-7 bg-white/90 rounded-sm flex items-center justify-center";

export const PhotoGrid = ({ photos, onChange, cover, onCover, favorites = [], testid = "photo-grid" }) => (
  <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-6 gap-2 mt-3" data-testid={testid}>
    {photos.map((p, k) => (
      <div key={p + k} className={`relative group aspect-square overflow-hidden bg-cream ${cover === p ? "ring-2 ring-sand" : ""}`}>
        <Thumb src={p} />
        {favorites.includes(p) && <Heart size={14} className="absolute bottom-1.5 left-1.5 text-white drop-shadow" fill="currentColor" />}
        {onCover && cover === p && <span className="absolute bottom-1 left-1 bg-white/95 text-[10px] font-medium px-1.5 py-0.5 rounded-sm" data-testid={`${testid}-cover-badge`}>Copertina</span>}
        <div className="absolute top-1 right-1 flex gap-1 opacity-0 group-hover:opacity-100 [@media(hover:none)]:opacity-100 transition-opacity">
          {k > 0 && (
            <button type="button" onClick={() => { const a = [...photos]; [a[k - 1], a[k]] = [a[k], a[k - 1]]; onChange(a); }} title="Sposta prima" className={btn} data-testid={`${testid}-left-${k}`}><ArrowLeft size={13} /></button>
          )}
          {onCover && (
            <button type="button" onClick={() => onCover(p)} title="Usa come copertina" className={btn} data-testid={`${testid}-cover-${k}`}>
              <Star size={13} fill={cover === p ? "#C5A880" : "none"} className="text-[#8a6d3f]" />
            </button>
          )}
          <button type="button" onClick={() => onChange(photos.filter((_, i) => i !== k))} title="Rimuovi" className={`${btn} text-terracotta`} data-testid={`${testid}-remove-${k}`}>
            <X size={14} />
          </button>
        </div>
      </div>
    ))}
  </div>
);
